import script from "./MainwaveScoreTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MainwaveScoreTable.vue?vue&type=script&setup=true&lang=js"

import "./MainwaveScoreTable.vue?vue&type=style&index=0&id=721c5b22&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-721c5b22"]])

export default __exports__